module.exports = __webpack_public_path__ + "img/erweima_zf.d8414b49.png";